import { FC, useMemo } from 'react';
import { CheckboxList, GenericItem } from '../CheckboxList';
import { useFormContext } from 'react-hook-form';
import { CohortType } from '@dynamika-shared/types/cohorts';
import { getLabelsForCollectionType } from './labelsUtils';
import { useClinicalTrialSlice } from '@restore/clinicalTrial/clinicalTrial.slice';

type LabelCheckboxListProps = {
  sourceType: string;
  path: string;
};

export const LabelCheckboxConditionList: FC<LabelCheckboxListProps> = ({
  sourceType,
  path,
}) => {
  const labels = useClinicalTrialSlice(state => state.data?.labelGroups || []);

  const items = useMemo(
    () => getLabelsForCollectionType(labels, sourceType),
    [labels, sourceType]
  );

  const { setValue, watch } = useFormContext();
  const condition = watch(path);

  const selectedItems = useMemo(() => {
    return Array.isArray(condition?.expected?.expected)
      ? condition.expected.expected
      : [];
  }, [condition]);

  const toggleInArray = (item: GenericItem, elements: string[]) => {
    return elements.includes(item.id as string)
      ? elements.filter(elId => elId !== item.id)
      : [...elements, item.id];
  };

  const clickHandler = (item: GenericItem) => {
    const updatedExpected = toggleInArray(
      item as CohortType,
      condition?.expected?.expected || []
    );
    setValue(path, {...condition, expected: {...condition.expected,expected: updatedExpected}  });
  };

  return (
    <CheckboxList
      items={items}
      onItemToggle={clickHandler}
      selectedItems={selectedItems}
    />
  );
};
